if ( typeof KlaviyoSignupTrigger !== 'function' ) {

	class KlaviyoSignupTrigger extends HTMLElement {

		constructor() {
			super();
			this.formId = this.dataset.formId;
			this.dismissDays = parseInt(this.dataset.dismissDays, 10) || 0;
			this.excludedUrls = (this.dataset.excludedUrls || '').split(/\r?\n/).map(pattern=>pattern.trim()).filter(Boolean);
			this.init();
		}

		async init() {
			await customElements.whenDefined('modal-box');
			const ageGate = document.querySelector('modal-box.popup-age-verification');
			if ( ageGate && ageGate._modalPending ) {
				ageGate.addEventListener('modal-box:hidden', ()=>{
					setTimeout(()=>{
						this.openForm();
					}, 500);
				}, { once: true });
			} else {
				this.openForm();
			}
		}

		async openForm() {
			if ( this.isExcludedUrl() || this.isSuppressed() || await this.isExistingProfile() ) {
				return;
			}
			window._klOnsite = window._klOnsite || [];
			window._klOnsite.push(['openForm', this.formId]);
		}

		isExcludedUrl() {
			return this.excludedUrls.some(pattern=>{
				const source = pattern.split('*').map(part=>part.replace(/[.+?^${}()|[\]\\]/g, '\\$&')).join('.*');
				return new RegExp(`^${source}$`, 'i').test(window.location.href);
			});
		}

		isSuppressed() {
			let formState = {};
			try {
				formState = JSON.parse(localStorage.getItem('klaviyoOnsite'))?.viewedForms?.modal?.disabledForms?.[this.formId] || {};
			} catch (e) {
				formState = {};
			}
			if ( formState.successActionTypes?.length > 0 ) {
				return true;
			}
			const lastCloseTime = formState.lastCloseTime;
			return lastCloseTime > 0 && lastCloseTime + this.dismissDays * 86400 > Math.floor(Date.now() / 1000);
		}

		async isExistingProfile() {
			if ( typeof window.klaviyo?.isIdentified !== 'function' ) {
				return false;
			}
			try {
				return await window.klaviyo.isIdentified() === true;
			} catch (e) {
				return false;
			}
		}

	}

	if ( typeof customElements.get('klaviyo-signup-trigger') == 'undefined' ) {
		customElements.define('klaviyo-signup-trigger', KlaviyoSignupTrigger);
	}

}
